import { z } from 'zod';

// Sync triggers and logs (/api/sync). SyncType and SyncRunStatus mirror the SyncLog model (the
// tests compare them).

const Positive = z.string().regex(/^[1-9]\d*$/, 'must be a whole number from 1');

export const SyncType = z.enum([
  'ibm_directory',
  'moodle',
  'manual',
  'registration',
  'attendance',
  'mentorship',
  'gravity',
  'eventbrite',
]);
export type SyncType = z.infer<typeof SyncType>;

export const SyncRunStatus = z.enum(['running', 'completed', 'failed', 'cancelled']);
export type SyncRunStatus = z.infer<typeof SyncRunStatus>;

export const SyncLogSortField = z.enum([
  'startedAt',
  'completedAt',
  'duration',
  'syncType',
  'status',
  'recordsProcessed',
  'recordsCreated',
  'recordsUpdated',
  'recordsSkipped',
]);
export type SyncLogSortField = z.infer<typeof SyncLogSortField>;

/** POST /api/sync/ibm-directory|moodle|mentorship|attendance take no body. */
export const SyncTriggerRequest = z.strictObject({});
export type SyncTriggerRequest = z.input<typeof SyncTriggerRequest>;

/** GET /api/sync/logs; blank filters mean none. */
export const SyncLogListQuery = z.strictObject({
  page: Positive.optional(),
  limit: Positive.optional(),
  syncType: z.union([SyncType, z.literal('')]).optional(),
  status: z.union([SyncRunStatus, z.literal('')]).optional(),
  sortBy: SyncLogSortField.optional(),
  sortOrder: z.enum(['ASC', 'DESC', 'asc', 'desc']).optional(),
});
export type SyncLogListQuery = z.input<typeof SyncLogListQuery>;

export const SyncLogIdParams = z.strictObject({ id: z.guid() });
export type SyncLogIdParams = z.input<typeof SyncLogIdParams>;

/** GET /api/sync/stats; days defaults to 30. */
export const SyncStatsQuery = z.strictObject({ days: Positive.optional() });
export type SyncStatsQuery = z.input<typeof SyncStatsQuery>;
